/* CX A/B test 2026-10-14. window.cxAB ('A'|'B') is set by the inline script in theme.liquid <head>.
   1) Tags the cart with attribute _cx_ab so every order records its test group.
   2) Variant B helpers: swipeable card images, rotating search placeholder. */
(function(){
  var v=window.cxAB; if(!v) return;
  function tag(){
    return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      if(!c.item_count||(c.attributes||{})._cx_ab===v) return;
      return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_cx_ab:v}})});
    }).catch(function(){});
  }
  var of=window.fetch;
  window.fetch=function(input){
    var p=of.apply(this,arguments);
    try{var u=typeof input==='string'?input:(input&&input.url)||'';if(/\/cart\/add/.test(u))p.then(function(){setTimeout(tag,400);});}catch(e){}
    return p;
  };
  tag();
  try{if(typeof window.gtag==='function')window.gtag('set','user_properties',{cx_ab:v});}catch(e){}
  if(v!=='B') return;
  var mob=window.matchMedia('(max-width:749px)');
  /* #9 rotating search placeholder */
  var ph=document.querySelector('.cx-msearch__ph');
  if(ph){var words=['kettles','choppers','French press','blender bottles','water bottles','milk frothers'],i=0;
    setInterval(function(){i=(i+1)%words.length;ph.textContent='Search '+words[i]+'…';},2600);}
  /* #7 card photo swipe: dots + tap opens the product */
  function cards(root){
    if(!mob.matches) return;
    (root||document).querySelectorAll('.card__media .media--hover-effect').forEach(function(m){
      var imgs=m.querySelectorAll(':scope > img'); if(imgs.length<2||m.dataset.cxSwipe) return; m.dataset.cxSwipe=1;
      var d=document.createElement('div');d.className='cx-dots';
      for(var k=0;k<imgs.length;k++){var b=document.createElement('i');if(!k)b.className='on';d.appendChild(b);}
      m.parentNode.appendChild(d);
      m.addEventListener('scroll',function(){var n=Math.round(m.scrollLeft/m.clientWidth);[].forEach.call(d.children,function(e,j){e.className=j===n?'on':'';});},{passive:true});
      m.addEventListener('click',function(){var a=m.closest('.card-wrapper');a=a&&a.querySelector('a.full-unstyled-link[href]');if(a)location.href=a.href;});
    });
  }
  if(document.readyState!=='loading')cards();else document.addEventListener('DOMContentLoaded',function(){cards();});
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(cards,400);}).observe(document.documentElement,{childList:true,subtree:true});
})();
